import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import {  H4 } from '@blueprintjs/core';
import {  Paper } from '@material-ui/core';
import Chart from 'react-apexcharts';
import { rounded } from '../../../utils.js'
//import {MAX_CHART_SIZE} from '../../../constants.js';

import './VocAll.css';
//import { ReceiptRounded } from '@material-ui/icons';

export const computeChartOption=(tab,label)=>{
    let filteredTab={};
    for (var key in tab) {
      if (key !=='__global__') {
        filteredTab[key]=tab[key]
      }
    }
   
    // prep data for the chart

    const series = [{
        name:label,
        data: Object.keys(filteredTab).sort().map( subCorpus => filteredTab[subCorpus]) 
    }];
    const options = {
      chart: {
        type: 'bar',
        height: 350
      },
      dataLabels: {
        enabled: false
      },
      plotOptions: {
        bar: {
          //columnWidth: '80%',
        }
      },
      yaxis: {
        title: {
          text: label,
        },
        labels: {
          formatter: function (y) {
            return rounded(y,2);
          }
        }
      },
      xaxis: {
        type: 'text',
        categories: Object.keys(filteredTab).sort(),
        labels: {
          rotate: -90
        }
      }
    }
    return [options, series]
}


class VocComparison extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { 
      currentKey:0 // the current key for the realSpec chart
    };
  }

  

  
  render() {
    const { t, nbDocs, nbParas, nbSents, nbCls, nbForms, vocSize, averageLength, size, lexicalDensity, STTR, nbToksDD, nbSentsDD, nbUtterancesDD } = this.props;

    //*******************************  nbDocs
    const [nbDocsOptions,nbDocsSeries]=computeChartOption(nbDocs,t('docNumber'));
    const nbDocsChart= 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={nbDocsOptions} 
              series={nbDocsSeries} 
              type="bar" 
              height={350} 
      />;


    //*******************************  nbParas
    const [nbParasOptions,nbParasSeries]=computeChartOption(nbParas,t('paraNumber'));
    const nbParasChart= 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={nbParasOptions} 
              series={nbParasSeries} 
              type="bar" 
              height={350} 
      />;

      //*******************************  nbSents
    const [nbSentsOptions,nbSentsSeries]=computeChartOption(nbSents,t('sentNumber'));
    const nbSentsChart= 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={nbSentsOptions} 
              series={nbSentsSeries} 
              type="bar" 
              height={350} 
      />;


    //*******************************  nbToks
    const [nbToksOptions,nbToksSeries]=computeChartOption(size,t('tokenNumber'));
    const nbToksChart= 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={nbToksOptions} 
              series={nbToksSeries} 
              type="bar" 
              height={350} 
      />;

    //*******************************  nbCls
    const [nbClsOptions,nbClsSeries]=computeChartOption(nbCls,t('clsNumber'));
    const nbClsChart= 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={nbClsOptions} 
              series={nbClsSeries} 
              type="bar" 
              height={350} 
      />;


    //*******************************  averageWordLength
    const [averageWordLengthOptions,averageWordLengthSeries]=computeChartOption(averageLength,t('averageLength'));
    const averageWordLengthChart= 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={averageWordLengthOptions} 
              series={averageWordLengthSeries} 
              type="bar" 
              height={350} 
      />;


    //*******************************  vocSize
    const [vocSizeOptions,vocSizeSeries]=computeChartOption(vocSize,t('vocSize'));
    const vocSizeChart= 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={vocSizeOptions} 
              series={vocSizeSeries} 
              type="bar" 
              height={350} 
      />;

    //*******************************  typeToken
    let typeToken={};
    for (var key in nbSents) {
      if (key !=='__global__') {
        typeToken[key]=rounded(vocSize[key]/size[key],3);
      }
    }
    const [typeTokenOptions,typeTokenSeries]=computeChartOption(typeToken,t('TTR'));
    const typeTokenChart= 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={typeTokenOptions} 
              series={typeTokenSeries} 
              type="bar" 
              height={350} 
      />;

    //******************************* STTR
    const [STTROptions,STTRSeries]=computeChartOption(STTR,t('STTR'));
    const STTRChart=(Object.keys(STTR).length!==0)? 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={STTROptions} 
              series={STTRSeries} 
              type="bar" 
              height={350} 
      />:"";


    //******************************* averageSentenceLength (cls)
    let filteredAverageSentenceLengthCls={};
    for (key in nbCls) {
      if (key !=='__global__') {
        filteredAverageSentenceLengthCls[key]=rounded(nbCls[key]/nbSents[key],2);
      }
    }
    const [averageSentenceLengthClsOptions,averageSentenceLengthClsSeries]=computeChartOption(filteredAverageSentenceLengthCls,t('averageSentLengthCls'));
    const averageSentenceLengthClsChart= 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={averageSentenceLengthClsOptions} 
              series={averageSentenceLengthClsSeries} 
              type="bar" 
              height={350} 
      />;      

    //******************************* averageParagraphLength
    let filteredAverageParagraphLength={};
    let noAverageParagraphLengthChart=false;
    const paraLengthTitle=nbForms ? t("formByPara") : t('averageParaLengthToks');
    for (key in nbParas) {
      if (key !=='__global__') {
        if (nbParas[key]) {
          filteredAverageParagraphLength[key]=nbForms[key]? rounded(nbForms[key]/nbParas[key],2) : rounded(size[key]/nbParas[key],2) ;
        } else {
          noAverageParagraphLengthChart=true;
        }
        
      }
    }
    const [averageParagraphLengthOptions,averageParagraphLengthSeries]=computeChartOption(filteredAverageParagraphLength,paraLengthTitle);
    const averageParagraphLengthChart= noAverageParagraphLengthChart? "":
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={averageParagraphLengthOptions} 
              series={averageParagraphLengthSeries} 
              type="bar" 
              height={350} 
      />;
    //******************************* averageSentenceLength (toks)
    let filteredAverageSentenceLength={};
    const sentLengthTitle = nbForms ? t("formBySent") : t('averageSentLengthToks');
    for (key in nbSents) {
      if (key !=='__global__') {
        filteredAverageSentenceLength[key] = nbForms[key] ? rounded(nbForms[key]/nbSents[key],2) : rounded(size[key]/nbSents[key],2);
      }
    }
    const [averageSentenceLengthOptions,averageSentenceLengthSeries]=computeChartOption(filteredAverageSentenceLength,sentLengthTitle);
    const averageSentenceLengthChart= 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={averageSentenceLengthOptions} 
              series={averageSentenceLengthSeries} 
              type="bar" 
              height={350} 
      />;

    //******************************* averageClauseLength
    let filteredAverageClauseLength={};
    const clsLengthTitle = nbForms ? t("formByCls") : t('averageClauseLengthToks');

    for (key in nbSents) {
      if (key !=='__global__' && nbCls && nbCls[key]!==0) {
        filteredAverageClauseLength[key] = nbForms[key]? rounded(nbForms[key]/nbCls[key],2) : rounded(size[key]/nbCls[key],2);
      }
    }
    const [averageClauseLengthOptions,averageClauseLengthSeries]=computeChartOption(filteredAverageClauseLength,clsLengthTitle);
    const averageClauseLengthChart= 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={averageClauseLengthOptions} 
              series={averageClauseLengthSeries} 
              type="bar" 
              height={350} 
      />;
    

    //******************************* lexicalDensity
    const [lexicalDensityOptions,lexicalDensitySeries]=computeChartOption(lexicalDensity,t('lexicalDensity'));
    const lexicalDensityChart= 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={lexicalDensityOptions} 
              series={lexicalDensitySeries} 
              type="bar" 
              height={350} 
      />;

    //******************************* proportion of direct discourse
    let propTokDD={};
    for (key in nbToksDD) {
      if (key !=='__global__' && size && size[key]!==0) {
        propTokDD[key]=rounded(nbToksDD[key]/size[key],2);
      }
    }
    const [propTokDDOptions,propTokDDSeries]=computeChartOption(propTokDD,t('propTokDD'));
    const propTokDDChart=(Object.keys(propTokDD).length!==0)? 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={propTokDDOptions} 
              series={propTokDDSeries} 
              type="bar" 
              height={350} 
      />:"";  

      //******************************* mean length of turns in direct discourse
      let meanUtteranceLengthDD={};
      for (key in nbUtterancesDD) {
        if (key !=='__global__' && nbUtterancesDD && nbUtterancesDD[key]!==0) {
          meanUtteranceLengthDD[key]=rounded(nbSentsDD[key]/nbUtterancesDD[key],2);
        }
      }
      const [meanUtteranceLengthDDOptions,meanUtteranceLengthDDSeries]=computeChartOption(meanUtteranceLengthDD,t('meanUtteranceLengthDD'));
      const meanUtteranceLengthDDChart=(Object.keys(meanUtteranceLengthDD).length!==0)? 
        <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
                options={meanUtteranceLengthDDOptions} 
                series={meanUtteranceLengthDDSeries} 
                type="bar" 
                height={350} 
        />:"";    
    return(
       <>
        <Paper className="margin-bottom-1-rem padding-1-rem">
            <div style={{
              display:"flex",
              flexWrap:"wrap", 
              flexDirection:"row",
              alignItems: "center"
              }}>

              <div id="nbDocsChart" className="column">
                  <H4>{t('docNumberColon')}</H4>
                  {nbDocsChart}
              </div>

              <div id="nbParasChart" className="column">
                  <H4>{t('paraNumberColon')}</H4>
                  {nbParasChart}
              </div>

              <div id="nbSentsChart" className="column">
                  <H4>{t('sentNumberColon')}</H4>
                  {nbSentsChart}
              </div>

              <div id="nbClsChart" className="column">
                  <H4>{t('clsNumberColon')}</H4>
                  {nbClsChart}
              </div>

              <div id="nbToksChart" className="column">
                  <H4>{t('tokenNumberColon')}</H4>
                  {nbToksChart}
              </div>              

              <div id="vocSizeChart" className="column">
                  <H4>{t('vocSizeColon')}</H4>
                  {vocSizeChart}
              </div>

              <div id="typeTokenChart" className="column">
                  <H4>{t('TTRColon')}</H4>
                  {typeTokenChart}
              </div>

              { STTRChart!=="" &&
                  <div id="STTRChart" className="column">
                    <H4>{t('STTRColon')}</H4>
                    {STTRChart}
                  </div>
              }


              <div id="averageWordLengthChart" className="column">
                  <H4>{t('averageWordLengthColon')}</H4>
                  {averageWordLengthChart}
              </div>

              <div id="averageParagraphLengthChart" className="column">
                  <H4>{paraLengthTitle} :</H4>
                  {averageParagraphLengthChart}
              </div>              
              
              <div id="averageSentenceLengthChart" className="column">
                  <H4>{sentLengthTitle} :</H4>
                  {averageSentenceLengthChart}
              </div>

              <div id="averageClauseLengthChart" className="column">
                  <H4>{clsLengthTitle} :</H4>
                  {averageClauseLengthChart}
              </div>

              <div id="averageSentenceLengthClsChart" className="column">
                  <H4>{t('averageSentLengthClsColon')}</H4>
                  {averageSentenceLengthClsChart}
              </div>

              <div id="lexicalDensityChart" className="column">
                <H4>{t('lexicalDensityColon')}</H4>
                {lexicalDensityChart}
              </div>

              { propTokDDChart!=="" &&
                  <div id="propTokDDChart" className="column">
                    <H4>{t('propTokDD')}</H4>
                    {propTokDDChart}
                  </div>
              }
              { meanUtteranceLengthDDChart!=="" &&
                  <div id="meanUtteranceLengthDDChart" className="column">
                    <H4>{t('meanUtteranceLengthDD')}</H4>
                    {meanUtteranceLengthDDChart}
                  </div>
              }
            </div>
        </Paper>
       </>
    );
  }
}

VocComparison.propTypes = {
    size:PropTypes.object,
    nbForms:PropTypes.object,
    nbSents:PropTypes.object,
    nbToksDD:PropTypes.object,
    nbUtterancesDD:PropTypes.object,
    nbDocs:PropTypes.object,
    nbParas:PropTypes.object,
    nbCls:PropTypes.object,
    vocSize:PropTypes.object,
    lexicalDensity:PropTypes.object,
    averageLength:PropTypes.object,
    STTR:PropTypes.object,
};

export default withTranslation()(VocComparison);
